import React, { forwardRef, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import { makeStyles } from "@material-ui/core/styles";
import axios from "axios";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";

/*user Components*/
import DepartmentsList from "../../departments/departmentsComponents/DepartmentsList";
import LanguageList from "../../languages/languagesComponents/LanguageList";
import UserProfile from "./UserProfile";

import Changes from "../../common/Changes";
import "./UserProfile.css";

const User = forwardRef((props) => {
  const [sysUser, setSysUser] = React.useState([]);
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [isSearched, setIsSearched] = useState(false);
  const [idUserProfile, setIdUserProfile] = useState(0);
  const [idDepartment, setIdDepartment] = useState(0);
  const [idlanguage, setIdLanguage] = useState(0);
  const [userInfo, setUserInfo] = useState(
    JSON.parse(localStorage.getItem("userInfo"))
  );

  const useStyles = makeStyles((theme) => ({
    root: {
      width: "100%",
      useState,
      "& .MuiTextField-root": {
        width: 200,
      },
      "& .MuiFormGroup-row": {
        justifyContent: "center",
      },
      "& .MuiFormControl-root": {
        justifyContent: "center",
      },
    },
    center: {
      margin: "0 auto",
      border: "1px grey black",
      textAlign: "center",
      width: "100%",
      "& .MuiTextField-root": {
        width: 200,
      },
      "& .MuiFormGroup-row": {
        justifyContent: "center",
      },
      "& .MuiFormControl-root": {
        justifyContent: "center",
      },
    },
  }));
  const classes = useStyles();
  let history = useHistory();

  useEffect(() => {
    //GetUserInfo();
  }, []);

  const GetUserInfo = () => {
    const url =
      process.env.REACT_APP_API_URL +
      "/USERS?filter=LoginName,eq," +
      props.sysUser.UserName;
    const timeout = setTimeout(() => {
      axios
        .get(url)
        .then((response) => response.data)
        .then((data) => {
          setSysUser(data.records);

          console.log("User data props", data);
        }, 500);

      return () => clearTimeout(timeout);
    });
  };

  const handleChangePassword = (event) => {
    setPassword(event.target.value);
  };

  const cellEditProp = {
    mode: "click",
    blurToSave: true,
    afterSaveCell: onAfterSaveCell, // a hook for after saving cell
  };
  function onAfterSaveCell(row, cellName, cellValue) {
    props.UpdateSysUser(row);
  }
  //subscribeToTimer((err, timestamp) => settimestamp(timestamp));

  const UpdateUserPass = () => {
    let userRequest = {
      IdUser: props.sysUser.idUser,
      Password: password,
      Reset_Password: true,
      LastModUser: userInfo.userId,
    };
    axios({
      method: "post",
      url: process.env.REACT_APP_API2_URL + "/User/Users_ResetPassword",
      //url: 'https://localhost:44337/api/User/Users_ResetPassword',
      data: userRequest,
    }).then((response) => {
      if (response.data === "0") {
        alert("Data Successfully Updated");
        setPassword("");
      }
      console.log("response", response);
    });
  };

  const setIdUserProfileOnMem = (IdProfile, row) => {
    setIdUserProfile(IdProfile);
    row.idUserProfile = IdProfile;
    props.UpdateSysUser(row);
  };

  const setIdDepartmentOnMem = (IdDepartment, row) => {
    setIdDepartment(IdDepartment);
    row.idDepartment = IdDepartment;
    props.UpdateSysUser(row);
  };

  const setIdLanguageOnMem = (IdLanguage, row) => {
    setIdLanguage(IdLanguage);
    row.idLanguage = IdLanguage;
    props.UpdateSysUser(row);
  };

  const userProfileFormatter = (cell, row) => {
    return (
      <UserProfile
        isInput={true}
        initialValue={cell}
        row={row}
        setIdUserProfileOnMem={setIdUserProfileOnMem}
      ></UserProfile>
    );
  };
  const departmentListFormatter = (cell, row) => {
    return (
      <DepartmentsList
        isInput={true}
        initialValue={cell}
        row={row}
        setIdDepartmentOnMem={setIdDepartmentOnMem}
      ></DepartmentsList>
    );
  };

  const languageListFormatter = (cell, row) => {
    return (
      <LanguageList
        isInput={true}
        initialValue={cell}
        row={row}
        setIdLanguageOnMem={setIdLanguageOnMem}
      ></LanguageList>
    );
  };

  return (
    <React.Fragment>
      {console.log("in user props", props)}
      {sysUser && (
        <div className="flex flex-col gap-4">
          <h3 className="text-lg font-semibold text-center">
            User Information
          </h3>
          <BootstrapTable
            cellEdit={cellEditProp}
            version="4"
            data={[props.sysUser]}
            hover
          >
            <TableHeaderColumn dataField="idUser" hidden isKey={true}>
              IdLineType
            </TableHeaderColumn>
            <TableHeaderColumn dataField="loginName">
              Login Name
            </TableHeaderColumn>
            <TableHeaderColumn dataField="name">Name</TableHeaderColumn>
            <TableHeaderColumn
              dataFormat={userProfileFormatter}
              editable={false}
              dataField="idUserProfile"
            >
              Profile
            </TableHeaderColumn>
          </BootstrapTable>
          <BootstrapTable
            version="4"
            data={[props.sysUser]}
            cellEdit={cellEditProp}
          >
            <TableHeaderColumn dataField="idUser" hidden isKey={true}>
              IdLineType
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="status"
              editable={{
                type: "checkbox",
                options: {
                  values: "true:false",
                },
              }}
            >
              Enable
            </TableHeaderColumn>
            <TableHeaderColumn
              dataFormat={departmentListFormatter}
              editable={false}
              dataField="idDepartment"
            >
              Department
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="idLanguage"
              dataFormat={languageListFormatter}
              editable={false}
            >
              Language
            </TableHeaderColumn>
          </BootstrapTable>
          <div className={`custom-card justify-between`}>
            <TextField
              size="small"
              className="flex-1 m-0"
              type="text"
              value={password != "" ? password : ""}
              variant="outlined"
              multiline={true}
              onChange={handleChangePassword}
            />
            <Button variant="contained" onClick={UpdateUserPass}>
              Reset Password
            </Button>
            <Changes
              title="User Changes"
              params={{
                ChangeType: 3,
                IdSport: "",
                Param1: props.sysUser.idUser,
                Param2: 0,
                Param3: 0,
              }}
            />
          </div>
        </div>
      )}
    </React.Fragment>
  );
});

export default User;
